// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_v9-8";
export var editMode = "_v9-3";
export var headerRow = "_v9-a";
export var headerTitle = "_v9-b";
export var product = "_v9-1";
export var productDetails = "_v9-5";
export var productDivider = "_v9-7";
export var productImage = "_v9-2";
export var productInfo = "_v9-4";
export var productTitle = "_v9-6";
export var strikethrough = "_v9-9";
export var upsellProductsCard = "_v9-0";